import React, { useState } from "react";
import Button from "../../../../components/common/button";
import { useNavigate } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./index.scss";
import { orders, renewal } from "../../../../utils/router/constant";
import { Col, Row } from "react-bootstrap";

const AlertCard = ({
  gifSrc,
  percentage = 0,
  title,
  subtitle,
  redirectlink,
  orderId,
  premiumAmount,
  cover,
  daysLeft,
  validTill,
  handleClick,
  type,
  cardType,
  buttonLabel,
  secondaryButtonLabel,
  handleSecondaryClick,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const navigate = useNavigate();

  const toggleDetails = () => {
    if (cardType === "PAYMENT_PENDING" || cardType === "KYC_PENDING") {
      navigate(orders);
    } else {
      navigate(renewal);
    }
  };

  const renderProgressContent = () => {
    if (gifSrc) {
      return (
        <div>
          <img src={gifSrc} alt="Countdown" />
          {cardType !== "PAYMENT_PENDING" && (
            <div className={`days-left ${type ? "days-left-grace" : ""}`}>
              {daysLeft}
            </div>
          )}
        </div>
      );
    }

    if (percentage !== 0 && percentage !== null) {
      return (
        <CircularProgressbar
          value={percentage}
          text={`${percentage}%`}
          strokeWidth={15}
          styles={buildStyles({
            textSize: "16px",
            pathTransitionDuration: 0.5,
            pathColor: `#FF8C57`,
            textColor: "#FF8C57",
            trailColor: "#E6E5E5",
          })}
        />
      );
    }

    return null; // Render nothing if no percentage or gifSrc
  };

  return (
    <div className={`alert--card ${cardType ? `alert--card-${cardType.toLowerCase()}` : ""} ${cardType === "KYC_PENDING" ? "alert--card-kyc" : ""}`}>
      <div className="gif-wrapper">{renderProgressContent()}</div>
      <div className="alert-content">
        <h1 className="alert--title">{title}</h1>
        <p className="alert--subtitle">{subtitle}</p>

        {gifSrc && (
          <Row className="policy-details">
            {/* Details Section */}
            {orderId ? (
              <Col
                xs="5"
                className="details-section"
              >
                <div className="detail-item">
                  <div className="details-label">Order ID</div>
                  <div className="details-value">#{orderId}</div>
                </div>
                {premiumAmount && (
                  <div className="detail-item">
                    <div className="details-label">Premium Amount</div>
                    <div className="details-value">{premiumAmount}</div>
                  </div>
                )}
                {cover && (
                  <div className="detail-item">
                    <div className="details-label">Cover</div>
                    <div className="details-value">{cover}</div>
                  </div>
                )}
                {cardType !== "PAYMENT_PENDING" && cardType !== "KYC_PENDING" && validTill && (
                  <div className="detail-item">
                    <div className="details-label">Valid Till</div>
                    <div className="details-value-date">{validTill}</div>
                  </div>
                )}
              </Col>
            ) : (
              <Col xs="4" />
            )}

            {/* Button Group */}
            <Col xs={cardType === "KYC_PENDING" ? "4" : "3"} className="button-group">
              {cardType !== "KYC_PENDING" && (
                <Button
                  type="button"
                  variant="secondary-notOulined"
                  label="View Details"
                  className="alert-btn view-details-btn"
                  onClick={toggleDetails}
                />
              )}
              {cardType === "RENEWAL" ? (
                <Button
                  type="button"
                  variant="primary"
                  label="Renew Now"
                  className="alert-btn renew-btn"
                  onClick={handleClick}
                />
              ) : (cardType === "PAYMENT_PENDING" || cardType === "KYC_PENDING") ? (
                <>
                  {secondaryButtonLabel && (
                    <Button
                      type="button"
                      variant="primary"
                      label={secondaryButtonLabel}
                      className="alert-btn renew-btn me-2"
                      onClick={handleSecondaryClick}
                    />
                  )}
                  <Button
                    type="button"
                    variant="primary"
                    label={buttonLabel || "Continue"}
                    className="alert-btn renew-btn"
                    onClick={handleClick}
                  />
                </>
              ) : null}
            </Col>
          </Row>
        )}

        {!gifSrc && (
          <Button
            type="button"
            variant="primary"
            label={buttonLabel || "Complete profile"}
            className="alert-btn"
            onClick={handleClick ? handleClick : () => navigate(redirectlink)}
          />
        )}
      </div>
    </div>
  );
};

export default AlertCard;
